<script setup>
import { computed, ref } from "vue";
import { mdiClose } from "@mdi/js";
import BaseButton from "@/Components/BaseButton.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import CardBoxPopup from "@/Components/CardBoxPopup.vue";
import OverlayLayer from "@/Components/OverlayLayer.vue";
import CardBoxComponentTitle from "@/Components/CardBoxComponentTitle.vue";
import { isIntegerKey } from "@vue/shared";

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    button: {
        type: String,
        default: "info",
    },
    buttonLabel: {
        type: String,
        default: "Aceptar",
    },
    hasCancel: Boolean,
    modelValue: {
        type: [String, Number, Boolean],
        default: null,
    },
    sizeModal: {
        type: String,
        default: "",
    }
});

// LRR
const resultConfirm = ref(false);
// AAC: const clasModal = ref('shadow-lg max-h-modal w-11/12 md:w-3/5 lg:w-2/5 xl:w-4/12 z-50')
// Tamños de modal
const clasModal = ref('shadow-lg container z-50 lg:h-[50vh] w-12/12 sm:w-8/12 lg:w-6/12 2xl:w-5/12 max-w-[600px]')
if (props.sizeModal == 'modal-2') {
    clasModal.value = 'shadow-lg container z-50 w-12/12 sm:w-8/12 lg:w-6/12 2xl:w-5/12 max-w-[600px]'
} else if (props.sizeModal == 'modal-3') {
    clasModal.value = 'shadow-lg container lg:h-[50vh] w-12/12 sm:w-8/12 lg:w-6/12 2xl:w-5/12 z-50 max-w-[700px]'
} 


const emit = defineEmits(["update:modelValue", "cancel", "confirm"]);

const value = computed({
    get: () => props.modelValue,
    set: (value) => emit("update:modelValue", value),
});

const confirmCancel = (mode) => {
    value.value = false;// LRR creo que cierra el modal CardBoxmodal
    emit(mode);

    // LRR
    //if (mode == "confirm") {
    //resultConfirm.value = true
    //}
    //console.log(emit(mode))

};

const confirm = () => confirmCancel("confirm");

const cancel = () => confirmCancel("cancel");

window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && value.value) {
        cancel();
    }
});

</script>

<template>
    <OverlayLayer v-show="value" @overlay-click="cancel">
        <CardBoxPopup v-show="value" :class="clasModal" is-modal>
            <!-- <CardBoxComponentTitle :title="title">
                
            </CardBoxComponentTitle> -->
            <div class="flex justify-end">
                <BaseButton v-if="hasCancel" :icon="mdiClose" color="whiteDark" small rounded-full
                    @click.prevent="cancel" style="" class="fixed m-4 border border-zinc-400 z-50"/>
            </div>
            

            <div class="space-y-3 h-full">
                <slot />
            </div>

            <!-- <template v-if="sizeModal!='full'" #footer>
                <BaseButtons>
                    <BaseButton :label="buttonLabel" :color="button" @click="confirm" />
                    <BaseButton v-if="hasCancel" label="Cancel" :color="button" outline @click="cancel" />
                </BaseButtons>
            </template> -->
        </CardBoxPopup>
    </OverlayLayer>
</template>
